<template>
  <el-form :inline="true" :model="queryParam" class="mainSearch" autocomplete="off">
    <el-form-item label="订单标识">
      <el-input v-model="queryParam.identifiername" placeholder="输入订单标识" />
    </el-form-item>
    <el-form-item>
      <el-button type="danger" @click="getListOrderIdentifier">查询</el-button>
      <el-button @click="resetSearch">重置</el-button>
      <el-button @click="goback">返回</el-button>
    </el-form-item>
  </el-form>
  <el-row>
    <el-col :span="24">
      <div class="mainTableTop">
       
        <el-button
          type="danger"
          @click="(dialog = true), doOrderIdentifierAdd()"
          v-hasPermission="['order:identifier']"
          >新增订单标识</el-button
        >
      </div>
    </el-col>
  </el-row>
  <el-row class="mainTableBox">
    <el-col :span="24" class="mpadding">
      <el-table
        :data="tableData"
        v-loading="loadingData"
        @selection-change="doSelectionGoods"
        class="mainTable"
        row-key="identifierid"
        height="600"
      >
        <!-- <el-table-column type="selection" width="55" /> -->
        <el-table-column label="标识ID" prop="identifierid" />
        <el-table-column label="订单标识" prop="identifiername" />
        <el-table-column label="操作" fixed="right">
          <template #default="scope">
            <el-link
              type="primary"
              size="small"
              @click="(dialog = true), doOrderIdentifierEdit(scope.$index, scope.row)"
              v-hasPermission="['order:identifier']"
              >编辑</el-link
            >

            <el-popconfirm
              confirm-button-type="danger"
              confirm-button-text="确定"
              cancel-button-text="取消"
              icon-color="#626AEF"
              title="您确定要删除此订单标识吗？"
              width="200px"
              @confirm="doOrderIdentifierDelete(scope.$index, scope.row)"
            >
              <template #reference>
                <el-link
                 v-hasRole="['admin']"
                  size="small"
                  type="danger"
                  >删除</el-link
                >
              </template>
            </el-popconfirm>
    
          </template>
        </el-table-column>
      </el-table>
    </el-col>
  </el-row>

  <el-row class="mainTableBottom">
    <el-col :span="8"
      ><div>
        <!-- <el-button
              type="danger"
              >添加用户</el-button> -->
      </div></el-col
    >
    <el-col :span="16">
      <div style="float: right">
        <el-pagination
          v-model:page-size="queryParam.pageSize"
          :page-sizes="[20, 50, 100, 300, 600, 1000, 2000]"
          :background="true"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="changeChangeSize"
          @current-change="changePage"
          :current-page="queryParam.pageNo"
        />
      </div>
    </el-col>
  </el-row>

  <el-drawer
    ref="drawerRef"
    v-model="dialog"
    :close-on-click-modal="false"
    :title="title"
    direction="rtl"
    size="55%"
    @close="doOrderIdentifierClose()"
  >
    <div class="common-drawer__content">
      <el-form
        ref="goodsFormRef"
        :model="goodsForm"
        :rules="rules"
        label-width="120px"
        autocomplete="off"
      >
      <el-form-item label="订单标识" prop="identifiername">
          <el-input
            v-model.trim="goodsForm.identifiername"
            placeholder="请输入订单标识"
          />
        </el-form-item>
      </el-form>
      <div class="common-drawer__footer">
        <el-button @click="doOrderIdentifierClose()">关闭</el-button>
        <el-button type="danger" :loading="loading" @click="doOrderIdentifierSave">{{
          loading ? "提交中 ..." : "提交"
        }}</el-button>
      </div>
    </div>
  </el-drawer>
</template>
        
<script setup>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { ElDrawer, ElTable, ElMessage } from "element-plus";
import { listOrderIdentifier, saveOrderIdentifier, deleteOrderIdentifier } from "@/api/order/identifier";
// import util from "@/util/tool.js";
import storage from  "@/util/storage";


// import store from "@/store";

const router = useRouter();
const goback = () => {
  router.go(-1);
};

let timer;

let dialog = ref(false);
const loading = ref(false);
const loadingData = ref(true);

const drawerRef = ref(ElDrawer);

const goodsFormRef = ref();

const total = ref(0);
const pageSize = ref(20); //每页显示条数

let title = ref("新增订单标识");

const multipleSelection = ref([]);
const doSelectionGoods = (val) => {
  multipleSelection.value = val;
};

//搜索查询
const queryParam = ref({
  pageNo: 1,
  pageSize: pageSize.value,
  identifiername: "",
  status: 1
});

const resetSearch = () => {
  queryParam.value = {
    pageNo: 1,
    pageSize: pageSize.value,
    identifiername: "",
    status: 1
  };
  getListOrderIdentifier();
};

const goodsForm = ref({
  identifierid: null,
  identifiername: null,
});


const tableData = ref([]);

//onMounted方法
onMounted(() => {
  let query = storage.getSessionObject("goodsPath")
  if (query) {
    queryParam.value = query
  }

  getListOrderIdentifier();
});


const doOrderIdentifierAdd = () => {
  title.value = "新增订单标识";
  resetForm()
};

const doOrderIdentifierDelete = (index, obj) => {
  deleteOrderIdentifier(obj).then((res) => {
    if (res.data.code === 1) {
      getListOrderIdentifier();
    } else {
      ElMessage.error(res.data.msg);
    }
  });
}

const doOrderIdentifierEdit = (index, obj) => {
  // console.log(index,obj)
  title.value = "编辑订单标识";
  goodsForm.value = obj;//直接赋值会出问题

  // let identifierid = obj.identifierid.toString()

  // getOrderIdentifierInfo({ identifierid}).then((res) => {
  //   goodsForm.value = res.data.extend.goods;
  //   goodsForm.value.identifierid = res.data.extend.goods.identifierid.toString()
  // });
};

const doOrderIdentifierClose = () => {
  loading.value = false;
  dialog.value = false;
  clearTimeout(timer);
  goodsFormRef.value.resetFields()
};

const resetForm = () => {
  goodsForm.value = {
    identifierid: null,
    identifiername: null,
  };
};

const doOrderIdentifierSave = () => {
  goodsFormRef.value.validate((valid) => {
    if (!valid) {
      //ElMessage("请先完善表单数据填写！");
      return;
    }  
    saveOrderIdentifier(goodsForm.value).then((res) => {
      loading.value = true;
      timer = setTimeout(() => {
        // 动画关闭需要一定的时间
        setTimeout(() => {
          loading.value = false;
        }, 400);
        if (res.data.code === 1) {
          getListOrderIdentifier();
          doOrderIdentifierClose();
        } else {
          ElMessage.error(res.data.msg);
        }
      }, 1000);
    });
  });
};

//分页
const changePage = (current) => {
  queryParam.value.pageNo = current;
  getListOrderIdentifier();
};
const changeChangeSize = (size) => {
  pageSize.value = size;
  queryParam.value.pageSize = size;
  getListOrderIdentifier();
};

//商品表API
const getListOrderIdentifier = () => {
  storage.remove('goodsTypePath')

  let query = JSON.parse(JSON.stringify(queryParam.value)); 

  listOrderIdentifier(query).then((res) => {//queryParam.value
    total.value = res.data.extend.pages.total;
    queryParam.value.pageSize = pageSize.value;
    tableData.value = res.data.extend.pages.list;
    loadingData.value = false
  });
};

//表单验证规则
const rules = ref({
  identifiername: [
    {
      required: true,
      message: "请输入订单标识",
      trigger: "blur",
    },
    {
      min: 2,
      max: 200,
      message: "订单标识长度2到200",
      trigger: "blur",
    },
  ],
});
</script>